"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FONT_FAMILY = void 0;
exports.DEFAULT_FONT_FAMILY = 'Inter, BlinkMacSystemFont, Helvetica, Arial, sans-serif';
//# sourceMappingURL=default_theme_attributes.js.map